module.exports = __webpack_public_path__ + "img/img10.19da3f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/05/img10.png
// module id = 241
// module chunks = 0